import { apiClient, assertOk } from "@/api/generated/client"

export const getBurnRate = async (): Promise<number> => {
  const { data, error, response } = await apiClient.GET("/api/ForHire/burn-rate")
  return assertOk(response, error, data)
}
